<template>
  <div>
    <dl v-if="feedstyle == 'news'" v-for="item in slicedItems" :key="item.id">
      <dt>{{ dateConv(item.date) }}</dt> <dd><a :href="item.link">{{ item.title.rendered }}</a></dd>
    </dl>

    <div v-if="feedstyle == 'blog'" class="blog_container">
      <div v-for="item in slicedItems" :key="item.id" class="col">
        <a :href="item.link" class>
          <div class="img_box" v-if="item.featured_image_urls !== null">
            <img :src="item.featured_image_urls.thumbnail[0]" alt />
          </div>
          <div class="img_box" v-else>
            <img src="/assets/img/common/no_image.png" alt="no image" />
          </div>
          <div class="txt_box">
            <h3 class="height_align">{{ item.title.rendered }}</h3>
            <div>{{ strReplace(item.excerpt.rendered) }}</div>
            <p class="date">{{ dateConv(item.date) }}</p>
          </div>
        </a>
      </div>
    </div>

    <div class="spinner_area">
      <pulse-loader :loading="isLoading" :color="'#0693e3'" :size="'10px'"></pulse-loader>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      total_count: 6,
      isLoading: false,
    };
  },
  props: {
    url: String,
    count: String,
    feedstyle: String
  },
  methods: {
    getPosts() {
      this.isLoading = true;
      var self = this;
      axios
        .get(this.url)
        // Success
        .then((response) => {
          if (response.status != 200) {
            // console.log(response.statusText);
            exit;
          }
          self.items = response.data;
          // console.log(response.data);
          this.isLoading = false;
        })
        // Error
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    dateConv(data){
      var newdate = new Date(data);
      var year = newdate.getFullYear();
      var month = newdate.getMonth() + 1;
      var day = newdate.getDate();
      return year + '年' + month + '月' + day + '日';
    },
    strReplace(data){//…[&hellip;]
      var replaced = data.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
      replaced = replaced.replace(/ \[&hellip;\]/g,'…');
      // console.log(replaced);
      return replaced;
    },
  },
  created() {
    if (this.count != null) {
      this.total_count = this.count;
    }
    this.getPosts();
  },
  computed: {
    slicedItems() {
      return this.items.slice(0, this.total_count);
    },
  },
};
</script>